import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { IS_PRODUCTION } from '@/constant'
import { useGetProjectandEmployeeCoutQuery } from '@/redux/service/employee'

interface ProjectWorkspaceTabsProps {
  readonly hidePendingSetup?: boolean
}

export function ProjectWorkspaceTabs({
  hidePendingSetup = false,
}: ProjectWorkspaceTabsProps) {
  const { data: count } = useGetProjectandEmployeeCoutQuery()
  const pendingCount = count?.data?.projectsPendingCount ?? 0

  const tabs: { to: string; label: string; end?: boolean }[] = [
    { to: '/', label: 'Active Projects', end: true },
    ...(!hidePendingSetup
      ? [{ to: '/projects/setup', label: 'Pending Setup' }]
      : []),
    ...(IS_PRODUCTION ? [{ to: '/health', label: 'Projects Health' }] : []),
  ]

  return (
    <div className='flex p-1 bg-muted border border-border rounded-xl gap-1 shrink-0 w-fit max-w-full overflow-x-auto h-9 items-stretch'>
      {tabs.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          {...(tab.end ? { end: true } : {})}
          className={({ isActive }) =>
            cn(
              'px-2 text-xs font-medium transition-all duration-200 rounded-lg flex items-center justify-center whitespace-nowrap gap-1.5',
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
            )
          }
        >
          {({ isActive }) => (
            <>
              {tab.label}
              {tab.to === '/projects/setup' && pendingCount > 0 && (
                <span
                  className={cn(
                    'min-w-[18px] px-1.5 py-0.5 rounded-full text-[10px] font-bold leading-[2] flex items-center justify-center',
                    isActive
                      ? 'bg-primary-foreground/20 text-primary-foreground'
                      : 'bg-destructive text-destructive-foreground'
                  )}
                >
                  {pendingCount}
                </span>
              )}
            </>
          )}
        </NavLink>
      ))}
    </div>
  )
}
